import 'date-fns';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';



export default function Step3() {
    const [effectedDate, setSelectedDate] = React.useState(new Date('2014-08-18T21:11:54'));

    const handleDateChange = (date) => {
      setSelectedDate(date);
    };
  return (
    <>
        <Grid container spacing={3}>
            <Grid item  xs={12} sm={6}>
                <TextField id="companyname" fullWidth  label="Company" />
            </Grid>
        </Grid>

      <Grid container spacing={3}>
        <Grid item  xs={12} sm={6}>
            <TextField id="insurancecompanyaddress" fullWidth label="Address" />
        </Grid>
        <Grid item  xs={12}  sm={2}>
            <TextField
            id="insurancecompanycity"
            fullWidth
            label="City"
            />
        </Grid>
        <Grid item  xs={12} sm={2}>
            <TextField id="insurancecompanyzip" fullWidth label="Zip" />
        </Grid>
        <Grid item  xs={12} sm={2}>
                <TextField id="insurancecompanyphone" fullWidth  label="Phone" />
            </Grid>
      </Grid>

        <Grid container spacing={3}>

             <Grid item  xs={12} sm={6}>
        <TextField id="insurancecompanynamedinsured" fullWidth label="Named Insured" />    
        </Grid>

        <Grid item  xs={12} sm={6}>
         <TextField id="insurancecompanyclaimno" fullWidth label="Clain No" />    
        </Grid>
      </Grid>

        <Grid container spacing={3}>
        <Grid item  xs={12}  sm={3}>
        <MuiPickersUtilsProvider   utils={DateFnsUtils} >
                <KeyboardDatePicker
                    margin="none"
                    id="date-of-birth"
                    fullWidth
                    label="Date of Birth "
                    format="MM/dd/yyyy"
                    value={effectedDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    />
                    </MuiPickersUtilsProvider>           
        </Grid>
        <Grid item  xs={12} sm={3}>
        <TextField id="insurancecompanyeffectivedatesto" fullWidth label="to" />
        </Grid>
      </Grid>


      <Grid container spacing={3}>
        <Grid item  xs={12} sm={6}>
            <TextField id="insurancecompanyaddresstwo" fullWidth label="Address" />
        </Grid>
        <Grid item  xs={12}  sm={2}>
            <TextField
            id="insurancecompanycitytwo"
            fullWidth
            label="City"
            />
        </Grid>
        <Grid item  xs={12} sm={2}>
            <TextField id="insurancecompanyziptwo" fullWidth label="Zip" />
        </Grid>
        <Grid item  xs={12} sm={2}>
                <TextField id="insurancecompanyphonetwo" fullWidth  label="Phone" />
            </Grid>
      </Grid>

        <Grid container spacing={3}>
        <Grid item  xs={12}  sm={6}>
        <TextField id="insurancecompanypolicyno" fullWidth label="Policy No " />           
        </Grid>
        <Grid item  xs={12} sm={6}>
        <TextField id="insurancecompanyadjuster" fullWidth label="Adjuster" />
        </Grid>
      </Grid>

        <Grid container spacing={3}>
        <Grid item  xs={12}  sm={3}>
        <TextField id="insurancecompanycoverage" fullWidth label="Coverage PI/PD $ " />           
        </Grid>

        <Grid item  xs={12}  sm={3}>
        <TextField id="insurancecompanymedpay" fullWidth label="Med-Pay $ " />           
        </Grid>

        <Grid item  xs={12}  sm={3}>
        <TextField id="insurancecompanyum" fullWidth label="UM $ " />           
        </Grid>

        <Grid item  xs={12}  sm={3}>
        <TextField id="insurancecompanycolded" fullWidth label="Col/Ded $" />           
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item  xs={12} sm={12}>
            <h3 style={{margin_top:25}}>Health Insurance</h3>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
            <Grid item  xs={12} sm={6}>
                <TextField id="healthcompanyname" fullWidth  label="Company" />
            </Grid>
        </Grid>

        <Grid container spacing={3}>
        <Grid item  xs={12} sm={6}>
            <TextField id="healthaddress" fullWidth label="Address" />
        </Grid>
        <Grid item  xs={12}  sm={2}>
            <TextField
            id="healthcity"
            fullWidth
            label="City"
            />
        </Grid>
        <Grid item  xs={12} sm={2}>
            <TextField id="healthzip" fullWidth label="Zip" />
        </Grid>
        <Grid item  xs={12} sm={2}>
                <TextField id="healthphone" fullWidth  label="Phone" />
            </Grid>
      </Grid>

      <Grid container spacing={3}>
            <Grid item  xs={12} sm={6}>
                <TextField id="healthnamedinsured" fullWidth  label="Named Insured" />
            </Grid>
        </Grid>

        <Grid container spacing={3}>
            <Grid item  xs={12} sm={6}>
                <TextField id="healthgroupplan" fullWidth  label="Group/Plan No" />
            </Grid>

            <Grid item  xs={12} sm={6}>
                <TextField id="healthpolicyno" fullWidth  label="Policy No" />
            </Grid>
        </Grid>


</>
    
  );

}
